import React, { useContext, useEffect, useState } from 'react';
import { AuthStatusContext, request } from '@trp-individual-investor-adv-disc/adv-shared';

import TransferContext from '../../../containers/TransferContainer/context';
import PageWrapper from '../../PageWrapper/PageWrapper';
import BeaconWrapper from '../BeaconWrapper/BeaconWrapper';
import AgreementSelection from '../AgreementSelection/AgreementSelection';
import transferData from './mocks/transferData.json';

const TransferHub = () => {

    const { applicationConfig } = useContext(AuthStatusContext).state;
    const { dispatch } = useContext(TransferContext);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (process.env.REACT_APP_MOCK) {
            dispatch({
                type: 'UPDATE_TRANSFER_DATA',
                payload: transferData
            })
            setLoaded(true);
        } else {
            request(
                applicationConfig,
                '/adv-disc-svc/service/v1/transfer',
                'get',
                {},
                null,
                '/usis/advice/checkout'
            )
            .then((response) => {
                dispatch({
                    type: 'UPDATE_TRANSFER_DATA',
                    payload: response.data,
                });
                setLoaded(true);
            });
        }
    }, [dispatch]);

    return (
        <PageWrapper classes='transfer-container-wrapper' bgColor='#F1F1F1' style={{marginBottom: '-121px', paddingBottom: '0px', paddingTop: '48px'}} >
            <BeaconWrapper>
                <AgreementSelection requestConfig={applicationConfig} transfersLoaded={loaded} />
            </BeaconWrapper>
        </PageWrapper>
    )
};

export default TransferHub;
